import { LeaderboardDesktop } from '@wwe-portal/ui/features/leaderboard/leaderboard';
import { LeaderboardMobile } from '@wwe-portal/ui/features/leaderboard/leaderboard';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';

import { FC } from 'react';

export const LeaderboardSkeleton: FC<{
  mobileHeader: React.ReactNode;
  desktopHeader: React.ReactNode;
  mobileRowHeader?: React.ReactNode;
  desktopRowHeader?: React.ReactNode;
  nRows: number;
  containerClassname?: string;
}> = ({
  mobileHeader,
  desktopHeader,
  mobileRowHeader,
  desktopRowHeader,
  nRows,
  containerClassname,
}) => {
  const data = Array.from({ length: nRows }, (_, index) => index);
  return (
    <>
      <LeaderboardMobile
        header={mobileHeader}
        rows={
          <>
            {mobileRowHeader}
            {data.map((item) => (
              <div className="rounded-xl px-5 py-4 odd:bg-[#3d426e]" key={item}>
                <Skeleton className="h-5 w-full" />
              </div>
            ))}
          </>
        }
      />
      <LeaderboardDesktop
        className={containerClassname}
        header={desktopHeader}
        rows={
          <>
            {desktopRowHeader}
            {data.map((item) => (
              <div className="even:bg-back400 rounded-xl px-5 py-4" key={item}>
                <Skeleton className="h-5 w-full" />
              </div>
            ))}
          </>
        }
      />
    </>
  );
};
